import 'client-only';
import { logger } from '@curology/logger/client';

import { type Brand } from '@/consts/brands';
import { type OfferResource } from '@/types/offers';
import { get, post } from '@/utils/http/client';
import { urls } from '@/utils/urls';

const getOffer = async (
  offerCategory: string,
  brand: Brand,
): Promise<{
  offer?: OfferResource;
}> => {
  try {
    const { data } = await get<{ offer?: OfferResource }>(
      urls[brand].api.offers.show(offerCategory),
    );
    return data;
  } catch (err) {
    logger.log(
      `Offer Cookie Tracking Failed for offer category ${offerCategory}: ${err}`,
    );
    return {};
  }
};

const updateUserOffer = async (
  offerCategoryId: number,
  brand: Brand,
): Promise<void> => {
  try {
    await post(urls[brand].api.offers.updateUserOffer, {
      offer_category_id: offerCategoryId,
    });
  } catch (err) {
    logger.log(
      `Failed to update user offer for offer category ${offerCategoryId}: ${err}`,
    );
  }
};

export const OffersService = {
  getOffer,
  updateUserOffer,
};
